export const optimizelyExperimentID = '199137497'
export const MAX_SSN_RETRIES = 2
